
export const loadEventImages = (folderName) => {
  try {
    const context = require.context(
      "../../assets/images/invitation_images/PC", // 🔒 static path (no ${folderName})
      true,                                    // ✅ recursive to go inside all folders
      /\.(svg|png|jpe?g)$/i                    // ✅ image types
    );
    console.log("images",folderName)
    // Filter only files that belong to the specific folder
    const images = context
      .keys()
      .filter((key) => key.includes(`/${folderName.toLowerCase()}/`))
      .map(context); // Converts keys to actual URLs

    return images;
  } catch (error) {
    console.error("Error loading images from folder:", folderName, error);
    return [];
  }
};
